import React from "react";
import { Helmet } from "react-helmet-async";

const SEOHead: React.FC = () => {
  return (
    <Helmet>
      <title>MallInHand - Your Complete Mall Companion</title>
      <meta
        name="description"
        content="Explore all malls, discover brands & stores, unlock exclusive offers, stay updated on events & buy parking tickets instantly - all in one premium app."
      />
      <meta
        name="keywords"
        content="mall, shopping, parking, WhatsApp, offers, events, stores, digital mall experience"
      />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="MallInHand - Your Complete Mall Companion"
      />
      <meta
        property="og:description"
        content="Explore all malls, discover brands & stores, unlock exclusive offers, stay updated on events & buy parking tickets instantly."
      />
      <meta property="og:url" content="https://mallinhand.com" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="MallInHand - Your Complete Mall Companion"
      />
      <meta
        name="twitter:description"
        content="Explore all malls, discover brands & stores, unlock exclusive offers, stay updated on events & buy parking tickets instantly."
      />
    </Helmet>
  );
};

export default SEOHead;
